import { useProjectsStore } from '@/store/projects';
import { watch } from 'vue';
import { useRouter } from 'vue-router';

export function useProjectTypeRedirect() {
  const projectsStore = useProjectsStore();
  const router = useRouter();

  watch(() => projectsStore.project, (newValue) => {
    if(
      newValue && router.currentRoute.value.meta?.type &&
      newValue.type !== 'all' &&
      newValue.type !== router.currentRoute.value.meta?.type
    ) {
      router.push({ name: 'ProjectSelector', params: { projectId: newValue.id } });
    }
  }, { immediate: true });
}
